export default __webpack_public_path__ + "static/media/NarutoOriginal.b5c327cf.jpeg";